import { PersonDTO } from "../dto/user/PersonDTO.ts";
import IUserRepository from "../interfaces/IUserRepository.ts";
import { IPersonState } from "../dto/user/IPersonState.ts";
import { IChallengeResponse } from "../dto/user/IChallengeResponse.ts";
import { ISolutionResponse } from "../dto/user/ISolutionResponse.ts";
import { IRepositoryError } from "../dto/errors/IRepositoryError.ts";
import BaseRepository from "@/repositories/implementations/BaseRepository.ts";
import { AxiosResponse } from "axios";
import { IQuestionnaireResponse } from "@/repositories/dto/user/IQuestionnaireResponse.ts";
import { IVerifyToken } from "@/repositories/dto/user/IVerifyToken.ts";
import ILaravelResource from "@/repositories/dto/laravel/ILaravelResource.ts";

export enum IMfaChallengePurpose {
  GetCardDetails = "get_card_details",
  ValidateEmail = "validate_email",
  ValidatePhone = "validate_phone",
}

export default class UserRepository extends BaseRepository implements IUserRepository {
  createPersonProfile(): Promise<PersonDTO> {
    return Promise.resolve({} as PersonDTO);
  }

  async getState(): Promise<IPersonState | void | undefined> {
    const response: AxiosResponse<ILaravelResource<IPersonState>> | void = await this.get("/person/state");
    if (response) {
      return response.data.data;
    }
  }

  updatePersonProfile(): Promise<PersonDTO> {
    return Promise.resolve({} as PersonDTO);
  }

  async getChallenge(purpose: IMfaChallengePurpose, challengeCode: string | null): Promise<IChallengeResponse | IRepositoryError | undefined> {
    const payload = {
      purpose
    };
    if (challengeCode) {
      payload["challengeCode"] = challengeCode;
    }
    const response: AxiosResponse<ILaravelResource<any>> | void = await this.post("/mfa/challenge", payload);
    if (response) {
      return response.data.data;
    }
  }

  async verifySolution(challengeCode: string, solutionCode: string): Promise<ISolutionResponse | IRepositoryError | undefined> {
    const payload = {
      "code": challengeCode,
      "solution": solutionCode
    };

    const response: AxiosResponse<ILaravelResource<any>> | void = await this.post("/mfa/solution", payload);
    if (response) {
      return response.data.data;
    }
  }

  async addPhone(countryCode: string, phone: string): Promise<{} | IRepositoryError | undefined> {
    const payload = {
      countryCode,
      phone
    };

    const response: AxiosResponse<{}> | void = await this.post("/person/addPhone", payload);
    if (response) {
      return {};
    }
  }

  async createPersonalProfile(profile: object): Promise<IQuestionnaireResponse | IRepositoryError | undefined> {
    const response: AxiosResponse<ILaravelResource<IQuestionnaireResponse>> | void = await this.post("/person/profile", profile);
    if (response) {
      return response.data.data;
    }
  }

  async createPersonalQuestionnaire(questionnaire: object): Promise<IQuestionnaireResponse | IRepositoryError | undefined> {
    const response: AxiosResponse<ILaravelResource<IQuestionnaireResponse>> | void = await this.post("/person/questionnaire", questionnaire);
    if (response) {
      return response.data.data;
    }
  }

  async getVerifyToken(): Promise<IVerifyToken | IRepositoryError | undefined> {
    const response: AxiosResponse<ILaravelResource<IVerifyToken>> | void = await this.post("/person/getVerifyToken", {});
    if (response) {
      return response.data.data;
    }
  }

  async updateReviewStatus(): Promise<object | IRepositoryError | undefined> {
    const response: AxiosResponse<ILaravelResource<object>> | void = await this.post("/person/updateReviewStatus", {});
    if (response) {
      return response.data.data;
    }
  }

  async createBusinessProfile(profile: object): Promise<IQuestionnaireResponse | IRepositoryError | undefined> {
    const response: AxiosResponse<ILaravelResource<IQuestionnaireResponse>> | void = await this.post("/business/profile", profile);
    if (response) {
      return response.data.data;
    }
  }

  async createBusinessOwners(owners: object): Promise<IQuestionnaireResponse | IRepositoryError | undefined> {
    const response: AxiosResponse<ILaravelResource<IQuestionnaireResponse>> | void = await this.post("/business/owners", owners);
    if (response) {
      return response.data.data;
    }
  }
}
